module.exports = __webpack_public_path__ + "img/swiper2.eaf030ed.png";